import "../assets/styles/Header.css";
import logo from "../assets/images/swaasa-logo.png";
import closeIcon from "../assets/images/close-icon.png";
import ProfileIcon from "../assets/images/profile-icon.png";
import { useNavigate } from "react-router-dom";
import Overlay from "react-bootstrap/Overlay";
import { useState, useRef, useEffect } from "react";
import axios from "../axios";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import VideoModal from "./VideoModal";

export default function Header() {
 
 useEffect(() => {
    // getProfileApi();
  }, []);

  const params = useParams();

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const target = useRef(null);

  const logOut = () => {
    localStorage.clear();
    dispatch({ type: "logout" });
    setShow(false);
    navigate("/");
  };

  const userName = localStorage.getItem("userName");

  const openGuideVideo = () => {
    setShowVideoModal(true);
  };

  return (
    <>
      <div className="Header">
        <div className="Header-main">
        <div style={{display:"flex", gap:'15px', alignItems:'center'}}>
        <img src={logo}></img>
        <span className="Header-text no-printme">Doctor Package</span>
        </div>
         
          {localStorage.getItem("accessToken") ? (
            <div style={{ display:"flex", gap:'15px', alignItems:'center' }}>
              <span
               className='guide'
                onClick={openGuideVideo}
              >
                Guide
              </span>
              <img
                src={ProfileIcon}
                ref={target}
                onClick={() => setShow(!show)}
                className="menuIcon no-printme"
              />
              <Overlay
                rootClose={true}
                onHide={(event) => {
                  setShow(false);
                }}
                target={target.current}
                show={show}
                placement="bottom"
              >
                {({
                  placement: _placement,
                  arrowProps: _arrowProps,
                  show: _show,
                  popper: _popper,
                  hasDoneInitialMeasure: _hasDoneInitialMeasure,
                  ...props
                }) => (
                  <div {...props} className="menuIcon-overlay">
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <span
                        style={{
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        {userName}
                      </span>
                    </span>

                    <span
                      className="Header-Log-out no-printme"
                      onClick={logOut}
                    >
                      Log out
                    </span>
                  </div>
                )}
              </Overlay>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <VideoModal show={showVideoModal} onHide={() => setShowVideoModal(false)} /> 
    </>
  );
}
